import ApiService from '@/common/api.service'

const RESOURCE = 'horoscope'
const HoroscopeService = {
  getHoroscope (params) {
    return ApiService.query(RESOURCE, params)
  }
}
export default HoroscopeService
